<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'detailsReceipt',
    components: {
      baseEdit,
    },
  };
</script>
